import { useState, useEffect, memo } from 'react'

import { Track } from 'livekit-client'
import { TrackReferenceOrPlaceholder } from '@livekit/components-core'

import { OpenTheTab, ScreenShareIcon } from '@/src/assets/icons'

import { useRoomContext } from '@/src/context'

import { useAppSelector } from '@/src/store/hooks'
import { selectBranding } from '@/src/store/slices/meetData'

interface IDirectorControlProps {
  trackReference: TrackReferenceOrPlaceholder
}

const DirectorControl = memo(function DirectorControl({ trackReference }: IDirectorControlProps) {
  const [visible, setVisible] = useState(false)
  const [participantId, setParticipantId] = useState<string>('')
  const { name } = useRoomContext()

  const getIdParticipant = () => {
    setParticipantId(trackReference.participant.identity)
  }

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.shiftKey && event.key === 'Enter') {
        setVisible(!visible)
      }
    }

    window.addEventListener('keydown', handleKeyDown)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [visible])

  const { text_primary_color } = useAppSelector(selectBranding)

  return (
    visible && (
      <>
        <a
          target="_blank"
          href={`/director/${name}?id=${participantId}&source=${Track.Source.Camera}`}
          className="lk-button lk-focus-toggle-button lk-open-tab"
          onClick={getIdParticipant}
        >
          <OpenTheTab fill={text_primary_color} />
        </a>

        <a
          target="_blank"
          href={`/director/${name}?id=${participantId}&source=${Track.Source.ScreenShare}`}
          className="lk-button lk-focus-toggle-button lk-open-share"
          onClick={getIdParticipant}
        >
          <ScreenShareIcon fill={text_primary_color} />
        </a>
      </>
    )
  )
}, areEqualProps)

function areEqualProps(prevProps: IDirectorControlProps, newProps: IDirectorControlProps) {
  return prevProps.trackReference === newProps.trackReference
}

export default DirectorControl
